import ShowroomAboutCompany from "./showroom-about-company";
import ShowroomCompanyContacts from "./showroom-company-contacts";
import ShowroomCompanyAddress from "./showroom-company-address";

export default ShowroomAboutCompany;

export {
    ShowroomCompanyContacts,
    ShowroomCompanyAddress
}